export default "/_next/static/images/verification-number-21966c82e78388c44b8c73d558d0ad9b.svg";